import { Fragment, useState } from "react";
import PropTypes from "prop-types";
import LabelForm from "pages/signup/form/labelForm";
import { useTranslation } from "react-i18next";
import Input from "components/input";
import RadioButtons from "components/radioButtons";
import UploadFile from "components/uploadFile";
import { ReactComponent as AttachIcon } from "images/auth/attach.svg";
import useUploadFiles from "pages/signup/hooks/useUploadFiles";
import Select from "components/select";

function VatExempt({
  data = {},
  register = () => {},
  watch = () => {},
  setValue = () => {},
  errors,
}) {
  const [t] = useTranslation();
  const isVatExempt = watch("isVatExempt");
  const [radios, setRadios] = useState([
    {
      title: t("Yes"),
      isActive: true,
    },
    { title: t("No"), isActive: false },
  ]);

  const { countries = [] } = data;

  const countriesOptions = countries.map((elem) => ({
    ...elem,
    label: elem.name,
    value: elem.id,
  }));

  const {
    vatRef,
    isUploading,
    vatFileName,
    uploadVatCertificate,
    removeVatCertificate,
  } = useUploadFiles({});

  return (
    <Fragment>
      <div className="flex">
        <LabelForm
          label={t("vatExemptApplicable")}
          labelClassName="text-primary font-bold text-[24px] md-max:text-[18px] not-italic pt-[16px] bg-white z-[3]"
        />
      </div>

      <div className="grid grid-cols-2 md-max:grid-cols-1 gap-[16px] max-w-[843px] sm-max:max-w-full pt-[10px] px-[0px] pb-[30px]  z-[3] bg-white border-b-[1px] border-solid border-default-color">
        <RadioButtons
          label={t("vatExempt")}
          contents={radios}
          onClick={(_, index) => {
            setValue("isVatExempt", !isVatExempt);

            const updatedContents = radios.map((elem, i) => {
              return { ...elem, isActive: i === index };
            });

            setRadios(updatedContents);
          }}
        />
        {isVatExempt && (
          <>
            <Select
              name={"vatCountry"}
              label={t("vatCountry")}
              placeholder={t("placeholderSelect", {
                field: t("vatCountry").toLowerCase(),
              })}
              value={
                watch("vatCountry")
                  ? countriesOptions.find(
                      (elem) => elem.id === watch("vatCountry")
                    )
                  : null
              }
              onChange={(e) => {
                setValue("vatCountry", e.value);
              }}
              register={register}
              isRequired={true}
              options={countriesOptions}
            />
            <Input
              label={t("vatRegistrationNumber")}
              placeholder={t("placeHolderType", {
                title: t("vatRegistrationNumber").toLowerCase(),
              })}
              type="string"
              name="vatRegistrationNumber"
              register={register}
              isRequired={true}
              labelClassName="text-primary font-semibold text-[16px]"
              inputClassName="flex h-[43px] w-full items-center gap-[8px] self-stretch rounded-[6px] border-[1px] border-solid border-default-color bg-transparent outline-none text-dark-gray font-regular text-[16px] not-italic  placeholder:font-regular placeholder:text-[16px] placeholder:not-italic placeholder:font-normal py-[16px] px-[14px]"
            />
            <UploadFile
              name={"vatCertification"}
              register={register}
              registerArgs={{
                required: vatFileName
                  ? false
                  : t("errorField", { field: t("vatCertification") }),
              }}
              label={t("vatCertification")}
              placeHolderLabel={t("attachUrVat")}
              icon={<AttachIcon />}
              isUploading={isUploading.vatCertification}
              getFile={(e, isDrag) => uploadVatCertificate(e, isDrag, setValue)}
              labelClassName="text-primary font-semibold text-[16px]"
              placeHolderContainerClassName={`flex p-[14px] justify-between items-center gap-[8px] self-stretch rounded-[6px] h-[43px] w-full min-w-[190px] sm-max:min-w-full sm-max:w-full border-[1px] border-dashed ${
                errors.vatCertification && !vatFileName
                  ? "border-red"
                  : "border-dark-gray"
              } cursor-pointer`}
              isRequired={true}
              errorMessage={
                errors.vatCertification ? errors.vatCertification.message : ""
              }
              ref={vatRef}
              fileName={vatFileName}
              onRemoveFile={(fileName) =>
                removeVatCertificate(fileName, setValue)
              }
            />
          </>
        )}
      </div>
    </Fragment>
  );
}

VatExempt.propTypes = {
  data: PropTypes.object,
  register: PropTypes.func,
  watch: PropTypes.func,
  setValue: PropTypes.func,
  errors: PropTypes.object,
};

export default VatExempt;
